// extracted by mini-css-extract-plugin
export default {"collection":"ChestCollection_collection__vdGta","chestbox":"ChestCollection_chestbox__U1FLj"};